import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaTimesCircle, FaClock } from 'react-icons/fa';

export const DashboardStats = ({ counts }) => (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-0 rounded-2xl">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="min-w-0 bg-white rounded-lg shadow-md p-3 sm:p-4"
        >
            <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                    <p className="text-sm text-gray-500">Pending</p>
                    <h3 className="lg:text-xl text-lg font-bold text-yellow-600">{counts.pending}</h3>
                    
                </div>
                <FaClock className="lg:text-xl text-lg text-yellow-600 shrink-0" />
               
            </div>
        </motion.div>
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="min-w-0 bg-white rounded-lg shadow-md p-3 sm:p-4"
        >
            <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                    <p className="text-sm text-gray-500">Accepted</p>
                    <h3 className="lg:text-xl text-lg font-bold text-green-600">{counts.accepted}</h3>
                </div>
                <FaCheckCircle className="lg:text-xl text-lg text-green-600 shrink-0" />
            </div>
        </motion.div>
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="min-w-0 bg-white rounded-lg shadow-md p-3 sm:p-4"
        >
            <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                    <p className="text-sm text-gray-500">Rejected</p>
                    <h3 className="lg:text-xl text-lg font-bold text-red-600">{counts.rejected}</h3>
                </div>
                <FaTimesCircle className="lg:text-xl text-lg text-red-600 shrink-0" />
            </div>
        </motion.div>
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="min-w-0 bg-white rounded-lg shadow-md p-3 sm:p-4"
        >
            <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                    <p className="text-sm text-gray-500">Expired</p>
                    <h3 className="lg:text-xl text-lg font-bold text-gray-600">{counts.expired}</h3>
                </div>
                <FaTimesCircle className="lg:text-xl text-lg text-gray-600 shrink-0" />
            </div>
        </motion.div>
    </div>
);

